/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/. */

// AUTOGENERATED BY glean_parser v14.5.2. DO NOT EDIT. DO NOT COMMIT.

import EventMetricType from '@mozilla/glean/private/metrics/event';

/**
 * Sampled capability probe for passkey/WebAuthn support, including PRF (Pseudo-
 * Random Function) extension support.
 * This emits a privacy-preserving, minimal capability snapshot to estimate
 * eligibility for passkeys and PRF.
 *
 * Generated from `webauthn.capabilities`.
 */
export const capabilities = new EventMetricType<{
  browser_family?: string;
  browser_major?: string;
  cg?: string;
  error_reason?: string;
  hyb?: string;
  os_family?: string;
  os_major?: string;
  ppa?: string;
  prf?: string;
  rel?: string;
  supported?: string;
  uvpa?: string;
}>(
  {
    category: 'webauthn',
    name: 'capabilities',
    sendInPings: ['events'],
    lifetime: 'ping',
    disabled: false,
  },
  [
    'browser_family',
    'browser_major',
    'cg',
    'error_reason',
    'hyb',
    'os_family',
    'os_major',
    'ppa',
    'prf',
    'rel',
    'supported',
    'uvpa',
  ]
);
